import { IEntity } from '@pf/shared-common';
import {
    Currency,
    InventoryBundleFragment,
    ItemDimension,
    PackingStatus,
    PackLineSearchRequestParams,
    PackLineViewModelCreateBody,
    PackLineViewModelRead,
    ProjectLineItemFragment,
    Weight,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type PackLineRead = PackLineViewModelRead & IEntity;
export type PackLineCreate = PackLineViewModelCreateBody;
export type PackLineSearchParams = PackLineSearchRequestParams;

export class PackLineDto implements IEntity {
    constructor(data: Partial<PackLineDto>) {
        Object.assign(this, data);
    }
    id!: string;
    packedQuantity?: number;
    status?: PackingStatus;
    packingListDate?: string;
    projectLineId?: string | null;
    packLineValue?: Currency;
    lineNumber?: number;
    packingListId?: string;
    bundle?: InventoryBundleFragment;
    projectLineItem?: ProjectLineItemFragment;
    customFields?: Array<CustomFieldDto> | null;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    weight?: Weight;
    dimensions?: ItemDimension;
}
